import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { HeadingItem } from 'components';
import { ItemDetailInfo } from 'components/item-verification';
import { TiHiRolloutContext, TripContext } from "contexts";
import dateFormat from "dateformat";
import React, { FC, Fragment, useContext } from 'react';
import { VerifiedMethod } from 'services/enums';
import { LineItem, OrderItem } from 'services/types';
import { IconOptions } from "types";
import './item-verification-details.scss';

type Props = {
    orderItemId: number | undefined
}

export const ItemVerificationDetails: FC<Props> = ({ orderItemId }) => {

    const tripContext = useContext(TripContext)
    const { isEligible: isTiHiEligible } = useContext(TiHiRolloutContext)

    const orderItem: OrderItem = tripContext.orderItems.find(lp => lp.id === orderItemId) ?? {} as OrderItem
    const lineItem: LineItem = tripContext.lineItems.find((item: LineItem) => item.id == orderItem.lineItemId) ?? {} as LineItem

    let rightHandIconDetails: IconOptions = { icon: faCheckCircle, size: '2x', color: '#76AB21' }
    let verifiedMethod = ''

    switch (orderItem.verifiedMethod) {
        case VerifiedMethod.Manual: verifiedMethod = "Manual"; break;
        case VerifiedMethod.VerifiedMultiple: verifiedMethod = "Mass"; break;
        case VerifiedMethod.Scanned: verifiedMethod = "Scanned"; break;
        case VerifiedMethod.ZeroShipped: verifiedMethod = "Zero Shipped"; break;
        case VerifiedMethod.SubjectToCount: verifiedMethod = "Subject To Count"; break;
        case VerifiedMethod.MassRefusal: verifiedMethod = "Mass Refusal"; break;
    }

    return (
        <div className={'item-verification-details'}>
            <HeadingItem text={(lineItem.longDescription ?? lineItem.description ?? 'Unknown Item').toLowerCase()} rightHandIcon={orderItem.verifiedMethod != null ? rightHandIconDetails : undefined} />
            <div className={'item-verification-details-id-info'}>
                <ItemDetailInfo title={'Dot Item ID'} value={orderItem.lineItemId} />
                <ItemDetailInfo title={'Customer Item ID'} value={orderItem.customerItemId ?? 'N/A'} />
                <ItemDetailInfo title={'Manufacturer Item ID'} value={lineItem.manufacturerItemId} />
                <ItemDetailInfo title={'UPC'} value={lineItem.universalProductCode} />
                {isTiHiEligible &&
                    <Fragment>
                        <ItemDetailInfo title={'Ti'} value={orderItem.ti ?? 'N/A'} />
                        <ItemDetailInfo title={'Hi'} value={orderItem.hi ?? 'N/A'} />
                    </Fragment>
                }
                {orderItem.verifiedMethod != null &&
                    <Fragment>
                        <ItemDetailInfo title={'Verified Method'} value={verifiedMethod!} />
                        <ItemDetailInfo title={'Verified Time'} value={orderItem.verifiedTime ? dateFormat(orderItem.verifiedTime, 'mm/dd/yy HH:MM') : 'N/A'} />
                    </Fragment>
                }
            </div>
            <div className={'item-verification-details-info-box'}>
                <div className={'bottom-left-box-info'}>
                    <ItemDetailInfo title={'UOM'} value={lineItem.unitOfMeasure} />
                    <ItemDetailInfo title={'Shelf Life'} value={lineItem.shelfLife} />
                    <ItemDetailInfo title={'HazMat'} value={lineItem.isHazMat ? 'Yes' : 'No'} />
                </div>
                <div className={'bottom-right-box-info'}>
                    <ItemDetailInfo title={'Unit Weight'} value={lineItem.unitWeight} />
                    <ItemDetailInfo title={'Unit Height'} value={lineItem.unitHeight} />
                    <ItemDetailInfo title={'Unit Width'} value={lineItem.unitWidth} />
                </div>
            </div>
        </div>
    )
}
